import Subtitle from '@/atoms/typography/Subtitle';

const InformationTitle = ({ children }) => {
  return <Subtitle overrideStyles={{ mb: 0.5 }}>{children}</Subtitle>;
};

export default InformationTitle;
